import { api } from "./api";
import * as outbox from "./outbox";
import { patch } from "./store";
import type { CompletionResult } from "./completion";

async function requireSynced() {
  const counts = await outbox.counts();
  if (counts.pending || counts.rejected) throw new Error("Sync and resolve this device's waiting work before completing or reopening the job.");
}
async function remember(jobId: string, result: CompletionResult) {
  // Merge only lifecycle fields; never replace parts, labour, notes or queued edits.
  await patch("job", jobId, {status: result.status, completed_at: result.completed_at, rev: result.rev});
  return result;
}
export async function completeJob(jobId: string, reviewToken: string, note: string) {
  await requireSynced();
  return remember(jobId, await api.jobs.complete(jobId, {review_token: reviewToken, confirmed: true, handover_note: note}));
}
export async function reopenJob(jobId: string, expectedRev: number, reason: string) {
  await requireSynced();
  return remember(jobId, await api.jobs.reopen(jobId, {expected_rev: expectedRev, reason}));
}
